var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"label":_vm.label || _vm.$localize('InputEmail.label'),"value":_vm.value,"rules":_vm.rules,"prepend-icon":"mdi-at","autofocus":_vm.autofocus},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }